import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73a57218"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-preview__radio" }
const _hoisted_2 = { class: "triangle-radio" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_5 = { class: "item-preview__content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-btn__icon" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "edit-btn__text" }, " Редактировать ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "item-form"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item-panel", {
      'item-panel--is-opened': _ctx.isOpened,
    }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(
        [
          'item-preview',
          {
            'item-preview--is-default': _ctx.isDefault,
          },
        ]
      ),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('setDefault')))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            type: "radio",
            checked: _ctx.isDefault
          }, null, 8, _hoisted_3),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "preview", {}, undefined, true)
      ]),
      _createElementVNode("div", {
        class: "item-preview__edit-btn edit-btn",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.edit && _ctx.edit(...args)), ["stop"]))
      }, _hoisted_8)
    ], 2),
    (_ctx.isOpened)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _renderSlot(_ctx.$slots, "form", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}